module.exports = __webpack_public_path__ + "static/media/ua.34be0ff7.svg";